export default {
  groups: [{
      styleClasses: 'col-sm-6 row',
      fields: [{
          type: 'input',
          inputType: 'text',
          label: 'Name',
          model: 'name',
          maxlength: 50,
          required: true,
          placeholder: "Name",
          validator: ['string'],
          styleClasses: 'col-sm-12'
        },
        {
          type: 'input',
          inputType: 'url',
          label: 'Website',
          model: 'website',
          required: true,
          placeholder: "Website",
          validator: ['url'],
          styleClasses: 'col-sm-12'
        },
        {
          type: "textArea",
          label: "About",
          model: "about",
          hint: "Max 500 characters",
          max: 500,
          placeholder: "About",
          rows: 4,
          validator: ['string'],
          styleClasses: 'col-sm-12'
        },
        {
          type: "select",
          label: "Status",
          model: "status",
          values: [
            "active",
            "inactive"
          ],
          styleClasses: 'col-sm-6'
        }
      ]
    },
    {
      styleClasses: 'col-sm-6 row',
      fields: [{
        type: "cropper",
        model: 'logo',
        package: 'croppie',
        label: 'Logo',
        required: true,
        options: {
          aspect: 1,
          width: 400,
          height: 225,
          resizable: false,
        },
        styleClasses: 'col-sm-12'
      }, ]
    }
  ]
}